import { Flex, Image, Text } from '@mantine/core';

import { isDarkBackground } from '@/utils/showLayoutElements';
import { partnerLogoMap } from '@/utils/partnership';
import { useFields } from '@/routes/hooks/useFields';

type PartnershipProps = {
  stepId: string;
};

export const Partnership = ({ stepId }: PartnershipProps) => {
  const fields = useFields();
  const partnership = fields?.partnership;
  const color = isDarkBackground(stepId) ? 'white' : 'black';

  const logoSrc = partnerLogoMap.get(`${partnership}`);

  return (
    <Flex
      align="center"
      style={{
        zIndex: 1,
      }}
    >
      <Text
        fz="m"
        c={color}
      >
        A proud partner of
      </Text>
      <Image
        src={logoSrc}
        style={{
          width: 78,
          marginLeft: 10,
        }}
      />
    </Flex>
  );
};
